<script>
export const group = 'TopLeft'
</script>

<script setup>
import CurrentProgram from '../kijk_live_qmusic_be_default/CurrentProgram.vue'
</script>

<template>
  <CurrentProgram key="current-program" v-bind="$props" class="font-ds-digital" />
</template>
